// `linkType` has a defaultValue of 'internalLink' (payload/src/fields/shared/link-type.ts),
// so an optional link group comes back populated even when nothing was picked.
// Checking `linkType` alone therefore always reads as "has a link", and
// site/payload-link.vue renders nothing when the target is missing — taking the
// wrapped content with it. Check for an actual target instead.
export const hasPayloadLink = (link?: Link | null): boolean => {
  if (!link) return false
  if (link.linkType === 'internalLink') return Boolean(link.internalLink?.value)
  if (link.linkType === 'externalLink') return Boolean(link.externalLink)
  return false
}
